var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube.24.icon_22zfT",
    clipPath: "url(#clip0_1671_649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4 4.51C21.9046 4.64943 22.3639 4.91847 22.7323 5.29038C23.1007 5.66229 23.3654 6.12413 23.5 6.63C24.02 8.51 24 12.43 24 12.43C24 12.43 24 16.32 23.5 18.19C23.3645 18.6971 23.0983 19.1597 22.7281 19.5317C22.3578 19.9037 21.8964 20.1721 21.39 20.31C19.51 20.81 12 20.81 12 20.81C12 20.81 4.5 20.81 2.61 20.29C2.10174 20.1536 1.63829 19.8859 1.26618 19.5138C0.894067 19.1417 0.626385 18.6783 0.49 18.17C0 16.32 0 12.4 0 12.4C0 12.4 0 8.5 0.5 6.63C0.637887 6.12352 0.903335 5.66086 1.27099 5.2862C1.63864 4.91155 2.09621 4.63742 2.6 4.49C4.49 4 12 4 12 4C12 4 19.51 4 21.39 4.51H21.4ZM9.6 8.81L15.86 12.41L9.6 16V8.8V8.81Z",
    fill: "white",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1671_649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFooter);
export default __webpack_public_path__ + "static/media/YoutubeFooter.0e6db11c090703e16c80c9b40ef44a5b.svg";
export { ForwardRef as ReactComponent };